var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridPlaceholder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1234_63156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 149,
    height: 149
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 149,
    width: 149,
    height: 149,
    transform: "rotate(-90 0 149)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1234_63156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149 295L-5.51129e-05 145.641",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 286.141L-5.51129e-05 136.782",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 277.282L-5.51129e-05 127.923",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 268.423L-5.51129e-05 119.064",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 259.564L-5.51129e-05 110.205",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 250.705L-5.51129e-05 101.347",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 241.847L-5.51129e-05 92.4877",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 232.988L-5.51129e-05 83.6288",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 224.129L-5.51129e-05 74.7699",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 215.27L-5.51129e-05 65.911",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 206.411L-5.51129e-05 57.0521",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 197.552L-5.51129e-05 48.1932",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 188.693L-5.51129e-05 39.3342",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 179.834L-5.51129e-05 30.4753",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 170.975L-5.51129e-05 21.6165",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 162.116L-5.51129e-05 12.7576",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 153.258L-5.51129e-05 3.89869",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 144.399L-5.51129e-05 -4.9602",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 135.54L-5.51129e-05 -13.8191",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 126.681L-5.51129e-05 -22.678",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 117.822L-5.51129e-05 -31.537",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 108.963L-5.51129e-05 -40.3959",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 100.104L-5.51129e-05 -49.2548",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 91.2452L-5.51129e-05 -58.1136",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 82.3864L-5.51129e-05 -66.9725",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 73.5275L-5.51129e-05 -75.8314",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 64.6685L-5.51129e-05 -84.6904",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 55.8096L-5.51129e-05 -93.5492",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 46.9507L-5.51129e-05 -102.408",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 38.0919L-5.51129e-05 -111.267",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 29.233L-5.51129e-05 -120.126",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 20.3741L-5.51129e-05 -128.985",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 11.5152L-5.51129e-05 -137.844",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 2.65631L-5.51129e-05 -146.703",
    stroke: "#6C6C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPlaceholder2);
export default __webpack_public_path__ + "static/media/grid-placeholder-2.097d2c6e90d6906d985bbc9fa8866e81.svg";
export { ForwardRef as ReactComponent };